export const isAndroid = () => /android/i.test(navigator.userAgent);

export const isMobile = () => /iPad|Tablet|Mobile|iPhone|Android/i.test(navigator.userAgent);
